var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mdi",class:{
		[ 'mdi-' + _vm.cls ]: true,
		crystal: _vm.crystal,
		clickable: _vm.clickable,
	},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }